import { db } from '../client/index';
import { collection, getDocs, doc, addDoc, deleteDoc, query, where } from 'firebase/firestore/lite';
import { getRole } from './roles.service';

const rolesUsersCollection = collection(db, 'roles-users');

export const getRoleByUser = async (userId) => {
  try {
    const querySnapshot = query(rolesUsersCollection, where('user', '==', userId));
    const queryItems = await (await getDocs(querySnapshot)).docs;
    const roles = queryItems.map(role => ({
      ...role.data(),
      id: role.ref.id
    }));
    if (roles[0]) {
      const roleItem = await getRole(roles[0].role)
      return {
        ...roleItem,
        userRole: roles[0].id
      };
    } else {
      return null;
    }
  } catch (err) {
    return err;
  }
}

export const addUserToRole = async (roleId, userId) => {
  try {
    const roleUser = {
      role: roleId,
      user: userId
    }
    const { id } = await addDoc(rolesUsersCollection, roleUser);
    const roleUserAdded = { id, ...roleUser };
    return roleUserAdded;
  } catch (err) {
    return err;
  }
}

export const deleteUserFromRole = async (id) => {
  try {
    const roleUserRef = doc(db, 'roles-users', id);
    await deleteDoc(roleUserRef);
    return id;
  } catch (err) {
    return err;
  }
}